export default __webpack_public_path__ + "static/tooltip-interactive-1-dont-light-994d234c5e871bfee0f64920036363f7.png";